import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-rose-600">
              About Me
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p> Hi,I'm Kidan,nice to meet you.Please take a look around!</p>
          </div>
          <div>
            <p>
              {" "}
              I have a deep passion for technology especially when it comes to
              figuring out how apps and websites are made and how they actually
              work behind the scenes. I've been teaching myself a lot, diving
              into the world of web development to uncover its secrets. Right
              now, I'm a student at Digital Career Institute, learning web
              development. I'm almost done with the backend part, and I'm
              excited to take on new challenges that will help me get even
              better.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
